import { Logger } from '@dupe/logger'

const logger = new Logger({
  service: 'web-dupe-com',
})

export default logger
